module.exports = __webpack_public_path__ + "img/bottom.e2cd12c2.png";